
export const addToPurchaseHistory = (purchase) => ({
  type: 'ADD_TO_PURCHASE_HISTORY',
  payload: purchase,
});
